<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { RouterView } from 'vue-router';
import BottomNav from './components/BottomNav.vue';
import InstallBanner from './components/InstallBanner.vue';
import ToastHost from './components/ToastHost.vue';

const ready = ref(false);
onMounted(() => {
  ready.value = true;
});
</script>

<template>
  <div class="min-h-screen flex flex-col">
    <main class="flex-1 pb-24 safe-top">
      <RouterView v-slot="{ Component }">
        <Transition name="fade" mode="out-in">
          <component :is="Component" />
        </Transition>
      </RouterView>
    </main>
    <BottomNav />
    <InstallBanner v-if="ready" />
    <ToastHost />
  </div>
</template>
